import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Card, CardContent } from '@/components/ui/card';
import { SwitchField } from '@/modules/common/components/molecules/inputs/switch-field';

import { FORM_FIELD_PRORATE_ACCRUAL } from '../../../../constants/time-off-type-form-fields';
import { TimeOffTypeSetupFormData } from '../../../../validations/time-off-type-validation';

interface ProrateAccrualSectionProps {
  form: UseFormReturn<TimeOffTypeSetupFormData>;
  isReadMode: boolean;
}

export function ProrateAccrualSection({ form, isReadMode }: ProrateAccrualSectionProps) {
  const { t } = useTranslation('authenticated.settings');

  return (
    <Card>
      <CardContent className="space-y-4 p-6">
        <div>
          <h3 className="text-md font-semibold">
            {t('pages.timeOff.details.sections.prorateAccrual.title')}
          </h3>
          <p className="mt-0.5 text-xs text-muted-foreground">
            {t('pages.timeOff.details.sections.prorateAccrual.description')}
          </p>
        </div>

        <SwitchField
          name={FORM_FIELD_PRORATE_ACCRUAL}
          control={form.control}
          label={t('pages.timeOff.details.sections.prorateAccrual.toggle')}
          disabled={isReadMode}
        />
      </CardContent>
    </Card>
  );
}
